<template lang="pug">
  SspLayout(area="core")
    template(slot="actions")
      .red(v-if="errorMsg") {{errorMsg}}

      .search.input-group.ml10
        input.form-control.order-input(v-model="code" placeholder="Go to section by code")
        span.input-group-btn
          button.btn.btn-default(:disabled="!isValidCode" @click="goToSectionCode()")
            i.fa.fa-search

      .search.input-group.ml10
        input.form-control.order-input(v-model="sectionId" placeholder="Go to section by id")
        span.input-group-btn
          button.btn.btn-default(:disabled="!isValidId" @click="goToSectionId(sectionId)")
            i.fa.fa-search

      router-link.btn.btn-primary.ml10(:to="{name: 'newSection', params: {orderId: orderId}}") Create New Section

    DataGrid(ref="grid" :fetch="fetchData" @error="$emit('error', $event)" url-page-param="page")
      tr(slot="thead")
        th Id
        th Roll Id
        th Range
        th Size
        th Product
        th Active
        th Max Validations
        th Validation Messages
        th
      tr(:class="!s.isGap ? 'clickable' : ''"  v-for="s in sections.content")
        td
          span(v-if="s.id") {{s.id}}
          router-link.btn.btn-sm.btn-default(v-if="s.isGap" :to="{name: 'newSection', params: {orderId: orderId}, query: {min: s.first.codeIndex, max: s.last.codeIndex}}")
            i.fa.fa-plus
            span.ml5 Create Section
        td {{s.rollId}}
        td(:title="!s.isGap ? s.first.code + ' - ' + s.last.code : ''") {{s.first.codeIndex}} - {{s.last.codeIndex}}
        td
          span(v-if="s && s.first && s.last") {{size(s.first.codeIndex, s.last.codeIndex)}}
        td
          a(v-if="s.product" @click.prevent.stop="goToProduct(s.product.id)") {{s.product.name}}
        td
          span(v-if="!s.isGap") {{s.enabled ? 'Yes' : 'No'}}
          span(v-if="s.isGap")
        td
          span(v-if="s.maxValidations") {{ s.maxValidations }}
          span(v-else-if="!s.isGap") ∞
        td {{s.responseMessages}}
        td.actions
          button.btn-view(@click="goToSection(s.id)" v-if="!s.isGap") View


</template>

<script>
import Core from '@/service/apis/Core'
import DataGrid from '@/components/ssp/DataGrid'
import Util from '@/service/Util'
import { cloneDeep } from '@/utils/lodash'

export default {
  data: () => ({
    sections: [],
    order: null,
    sectionId: null,
    code: null,
    errorMsg: null
  }),
  methods: {
    createSection(first, last) {
      if (this.sections.length > 0) {
        this.$router.push({ name: 'editSection', params: { orderId: this.orderId }, query: { min: first, max: last } })
      } else {
        this.$router.push({ name: 'editSection', params: { orderId: this.orderId }, query: { min: this.order.firstCode.codeIndex, max: this.order.lastCode.codeIndex } })
      }
    },
    goToSectionCode() {
      Core.codeInfo(Util.sanitizeCode(this.code))
        .then((resp) => {
          if (!resp.data.length) {
            this.errorMsg = 'This is not a valid code'
          } else if (resp.data[0].orderId === this.orderId && resp.data[0].sectionId) { // TODO: Handle multiple results
            this.$router.push({ name: 'section', params: { orderId: this.orderId, sectionId: resp.data[0].sectionId } })
          } else {
            this.errorMsg = 'This code does not belong to any section in this order'
          }
        })
    },
    goToSectionId(id) {
      Core.getSection(id)
        .then((resp) => {
          if (resp.data.orderId === this.orderId) {
            this.$router.push({ name: 'section', params: { orderId: this.orderId, sectionId: id } })
          } else {
            this.errorMsg = 'The section belongs to another order'
          }
        })
    },
    getOrder() {
      if (!this.order) {
        return Core.getOrder(this.orderId)
          .then((resp) => {
            this.order = resp.data
          })
      }
      return Promise.resolve(this.order)
    },
    fetchData(page) {
      const req = page.pageRequest()
      return this.getOrder()
        .then(() => Core.listSectionsInOrder(this.orderId, req))
        .then((resp) => {
          this.sections = resp.data
          this.sections.content = this.renderMissingSections()
          return resp.data.totalElements
        })
    },
    renderMissingSections() {
      let result = cloneDeep(this.sections.content)
      if (!result.length) {
        if (this.order.size) {
          result = [
            {
              first: { codeIndex: 0 },
              last: { codeIndex: this.order.size - 1 },
              isGap: true
            }
          ]
        }
        return result
      }

      if (this.sections.number === 0 && result.length !== 0 && result[0].first.codeIndex !== 0 && result[0].first.codeIndex < this.order.size) {
        result.unshift({
          first: { codeIndex: 0 },
          last: { codeIndex: result[0].first.codeIndex - 1 },
          isGap: true
        })
      }

      for (let i = 0; i < result.length - 1; i += 1) {
        const current = result[i]
        const next = result[i + 1]
        if (current.last.codeIndex + 1 !== next.first.codeIndex) {
          result.splice(i + 1, 0, {
            first: { codeIndex: current.last.codeIndex + 1 },
            last: { codeIndex: next.first.codeIndex - 1 },
            isGap: true
          })
        }
      }
      if (this.sections.last && result[result.length - 1].last.codeIndex < this.order.size - 1) {
        result.push({
          first: { codeIndex: result[result.length - 1].last.codeIndex + 1 },
          last: { codeIndex: this.order.size - 1 },
          isGap: true
        })
      }
      return result
    },
    size(first, last) {
      return (last - first) + 1
    },
    goToSection(id) {
      this.$router.push({ name: 'section', params: { orderId: this.orderId, sectionId: id } })
    },
    goToProduct(id) {
      this.$router.push({ name: 'product', params: { id } })
    },
  },
  computed: {
    isValidId() {
      return this.sectionId
    },
    isValidCode() {
      return this.code
    },
    orderId() {
      return parseInt(this.$route.params.id, 10)
    }
  },
  components: {
    DataGrid
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/core/order/section/Sections.vue